export default __webpack_public_path__ + "static/media/btd6.8ec90e7a.webp";